import {useDebugValue} from 'react';

import {useSettings} from './';

const defaultSettings = {
    disableButton: false,
    isOpen: false,
    readOnly: false
};

function useGuestsSettings(props) {
    const {
        guestsSettings: propsSettings
    } = props;

    const {
        initialSettings,
        settings,
        changeSettings
    } = useSettings(defaultSettings, propsSettings);

    const result = {
        initialSettings,
        settings,
        changeSettings
    };

    useDebugValue(result);

    return result;
}

export {useGuestsSettings};
